import styled from "styled-components";
export const StructureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(1200px, 100%);
  margin: 0 auto;
`;
export const MainHeader = styled.h1`
  font-size: 3rem;
  margin: 2rem 0;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;
export const AddSectorButton = styled.button`
  padding: 8px 22px;
  color: ${({ theme: { colors } }) => colors.white};
  background-color: ${({ theme: { colors } }) => colors.black};
  align-self: flex-start;
`;
export const SectorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 2rem;
  gap: 1rem;
`;
export const SectorDetails = styled.div``;
export const SectorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 8px;
  padding: 1rem;
  width: 100%;
  height: 60px;
`;
export const SectorName = styled.h3`
  font-size: 1.2rem;
`;
export const ActionsContainer = styled.div`
  display: flex;
  gap: 1.5rem;
`;
export const AddSiteButton = styled.button`
  color: ${({ theme: { colors } }) => colors.ceruleanFrost};
  background: transparent;
`;
export const Sites = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
`;
export const Site = styled(SectorContainer)`
  border: 2px solid ${({ theme: { colors } }) => colors.white};
  background-color: transparent;
  height: 45px;
  width: 95%;
  margin: 0 auto;
  border-radius: 8px;
`;
export const SiteName = styled.p`
  font-size: 1rem;
  direction: ltr;
`;
